import LogoMark from "./LogoMark";
import { useLang } from "../i18n/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-cream/10 bg-espresso py-14 text-cream" data-testid="footer">
      <div className="mx-auto flex max-w-7xl flex-col gap-10 px-5 sm:px-8 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="flex items-center gap-3">
            <LogoMark className="h-9 w-auto" tone="#D4A373" dot="#FBF8F0" />
            <span className="font-serif text-xl tracking-wide">The Things We Keep</span>
          </div>
          <p className="mt-4 font-serif text-lg italic text-cream/60" data-testid="footer-tagline">
            {t.footer.tagline}
          </p>
        </div>

        <div className="flex flex-col gap-2 text-sm md:items-end">
          <p className="text-xs text-cream/40">{t.footer.made}</p>
          <p className="text-xs text-cream/40">
            © {year} The Things We Keep · {t.footer.unique}
          </p>
        </div>
      </div>
    </footer>
  );
}
